import { render, staticRenderFns } from "./real-list.vue?vue&type=template&id=ac31ebfa&scoped=true&"
import script from "./real-list.vue?vue&type=script&lang=js&"
export * from "./real-list.vue?vue&type=script&lang=js&"
import style0 from "./real-list.vue?vue&type=style&index=0&id=ac31ebfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac31ebfa",
  null
  
)

export default component.exports